import { inject, Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { GlobalStore } from '../../../../store/global.global-store';
import { getContractSettings } from './contract.utils';
import { SocialServiceContractQuantityEnum } from '@libs/types/src/services/enum/social-service-contract-quantity.enum';
import { gqlApi, routeParams } from '../../../../modules/shared/shared.global-service';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';

@Injectable({
    providedIn: 'root',
})
export class ContractsGuard implements CanActivate {
    private readonly globalStore = inject(GlobalStore);
    private readonly router = inject(Router);

    async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const serviceSettings = this.globalStore.currentService()?.serviceSettings;

        if (!serviceSettings) return false;

        const contractSettings = getContractSettings(serviceSettings);
        if (contractSettings?.quantity === SocialServiceContractQuantityEnum.MULTIPLE) return true;

        const data = await gqlApi.getFolderContracts(
            new FilterBuilder().folderId(routeParams.folderId()).limit(1).filter(),
            'id',
        );
        const contract = data?.items?.[0];

        await this.router.navigateByUrl(state.url + (contract ? `/${contract.id}` : '/create'));
        return false;
    }
}
